import React from "react";
import { BsLinkedin } from "react-icons/bs";
import { FaGithub } from "react-icons/fa";
import { BsSkype } from "react-icons/bs";

const HeaderSocials = () => {
  return (
    <div className="header__socials">
      <a
        href="https://www.linkedin.com/in/sharmil-macwan-549bb3213/"
        target="_blank"
      >
        <BsLinkedin />
      </a>
      <a href="https://github.com/sharmil01" target="_blank">
        <FaGithub />
      </a>
      <a href="https://join.skype.com/invite/unqt1JbQJTT2" target="_blank">
        <BsSkype />
      </a>
    </div>
  );
};

export default HeaderSocials;
